export enum SrStatusEn {
    AmendmentInProgress = "Amendment In Progress",
    Approved = "Approved",
    ApprovedAndPaymentAwaited = "Approved and Payment Awaited",
    AssignedToCS = "Assigned to CS",
    AwaitingCarnetReturn = "Awaiting Carnet Return",
    AwaitingClarification = "Awaiting Clarification",
    AwaitingDischarge = "Awaiting Discharge",
    AwaitingFinalPayment = "Awaiting Final Payment",
    AwaitingOriginalCarnet = "Awaiting Original Carnet",
    Booked = "Booked",
    Closed = "Closed",
    Draft = "Draft",
    DraftingInProgress = "Drafting In Progress",
    ExcessPaid = "Excess Paid",
    InProgress = "In Progress",
    Obsolete = "Obsolete",
    Open = "Open",
    OriginalCarnetReceived = "Original Carnet Received",
    Paid = "Paid",
    PaymentReceived = "Payment Received",
    PendingApproval = "Pending Approval",
    Rejected = "Rejected",
    ReviewInProgress = "Review In Progress",
    ReviewedWithComments = "Reviewed with Comments",
    SubmittedForApproval = "Submitted for Approval",
    VenueBooked = "Venue Booked",
    Cancelled = "Cancelled",
    NOCCertificateApproved="NOC Certificate Approved",
    PendingNOC = "Pending NOC",
    CancellationRequested="Cancellation Requested"
}
export enum SrStatusAr {
    AmendmentInProgress = "Amendment In Progress",
    Approved = "معتمد",
    ApprovedAndPaymentAwaited = "وافق وينتظر الدفع",
    AssignedToCS = "Assigned to CS",
    AwaitingCarnetReturn = "إنتظار إعادة دفتر الإدخال المؤ",
    AwaitingClarification = "بانتظار توضيح",
    AwaitingDischarge = "Awaiting Discharge",
    AwaitingFinalPayment = "بانتظار الدفعة النهائية",
    AwaitingOriginalCarnet = "Awaiting Original Carnet",
    Booked = "تم التسجيل",
    Closed = "مغلق",
    Draft = "لم يبدأ",
    DraftingInProgress = "Drafting In Progress",
    ExcessPaid = "الزائدة المدفوعة",
    InProgress = "قيد التنفيذ",
    Obsolete = "قديم",
    Open = "فتح",
    OriginalCarnetReceived = "Original Carnet Received",
    Paid = "مدفوع",
    PaymentReceived = "Payment Received",
    PendingApproval = "في انتظار الموافقة",
    Rejected = "مرفوض",
    ReviewInProgress = "جاري التدقيق",
    ReviewedWithComments = "تمت المراجعة مع وجود تعليقات",
    SubmittedForApproval = "مقدم للاعتماد",
    VenueBooked = "تم حجز القاعة",
    Cancelled = "تم الإلغاء",
    NOCCertificateApproved="اعتماد شهادة عدم الممانعة",
    PendingNOC = "بانتظار عدم الممانعة",
    CancellationRequested="تم طلب الإلغاء"
}

// --- Proxy wrapper ---
type Lang = "en" | "ar";
// This method is used to get lang
function getLang(): Lang {
    return (localStorage.getItem("selectedLang") as Lang) || "en";
}
export const SrStatus = new Proxy(SrStatusEn, {
    // This method is used to get using  and prop
    get(_, prop: string) {
        const lang = getLang();
        if (lang === "ar") {
            return (SrStatusAr as any)[prop];
        }
        return (SrStatusEn as any)[prop];
    }
});